import { ProviderAuthenticationCommon } from '~/plugins/data-connector/authentication/common'

export const ProviderGmailCommon = {
  key: 'gmail',
  authentication: ProviderAuthenticationCommon.Oauth2({
    key: 'gmail',
    authUrl: 'https://accounts.google.com/o/oauth2/auth',
    tokenUrl: 'https://oauth2.googleapis.com/token',
    scopes: ['email', 'https://www.googleapis.com/auth/userinfo.profile'],
    authParams: {
      include_granted_scopes: true,
    },
  }),
}

export type ProviderGmailAccountType = {
  /**
   * @deprecated Use lastMessageDate instead
   */
  lastMessageId?: string
  lastMessageDate?: number
  email: string
  name: string
}

export type GmailAttachment = {
  id: string
  filename: string
  mimeType: string
  size: number
}

export enum GmailScope {
  Send = 'https://www.googleapis.com/auth/gmail.send',
  Compose = 'https://www.googleapis.com/auth/gmail.compose',
  Modify = 'https://www.googleapis.com/auth/gmail.modify',
}
